
export const UAPAdExtensionType = {
  SiteLink: 'SiteLink',
  Callout: 'Callout',
  Promotion: 'Promotion',
  StructuredSnippet: 'StructuredSnippet',
  Price: 'Price',
};
